import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { camelToSnake, snakeToCamel } from "caseparser";

export const weightsApi = api
  .enhanceEndpoints({
    addTagTypes: ["weights", "weight"],
  })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      weights: builder.query({
        query: ({ personalInformationId, status }) => ({
          url: `weights`,
          method: RequestMethod.GET,
          params: camelToSnake({
            personalInformationId,
            status,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["weights"],
      }),
      weight: builder.query({
        query: ({ personalInformationId, status, id }) => ({
          url: `weights/${id ?? "0"}`,
          method: RequestMethod.GET,
          params: camelToSnake({
            personalInformationId,
            status,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["weight"],
      }),
    }),
  });

export const { useWeightQuery, useWeightsQuery } = weightsApi;
